import { use } from "react";

import { IProductsData } from "@faire/retailer/views/brand/contexts/utils/productsDataAggregator";

import { useBrandPageProductsStateContext } from "../contexts/BrandPageProductsStateContext";

export const useBrandProductsData = (): IProductsData | undefined => {
  const { productsQueryPromise, legacyProductsQueryData } =
    useBrandPageProductsStateContext();
  if (productsQueryPromise) {
    return use(productsQueryPromise);
  }
  return legacyProductsQueryData;
};
